<div class="modal fade show custom_popup custom_popup_responsive justify-content-center"
     tabindex="-1"
     role="dialog"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">
          Make Withdrawal
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="closeModal()"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body padding-model form-editing">

        <div class="row">
          <div class="col-lg-12 p-0">
            <div class="card w-100">
              <div class="card">
                <form *ngIf="withdrawFundForm" [formGroup]="withdrawFundForm" (keydown.enter)="$event.preventDefault()">
                  <div class="row">
                    <div style="width: 57px;"
                         class="custom-margin-1 align-items-center daterange_sec select_bank_filter">
                      <div class="mt-3">
                        <label for="ccy" class="form-title text-nowrap "><span class="required">*</span> Ccy</label>
                        <select
                          class="custom-form-select border-radius-100"
                          id="ccy"
                          formControlName="ccy"
                        >
                          <option *ngFor="let ccy of allCcyData" [value]="ccy.id">
                            {{ ccy.name }}
                          </option>
                        </select>
                      </div>
                      <app-form-error-component [control]="withdrawFundForm.controls['ccy']" />
                    </div>

                    <div style="width: 95px;" class="field-groups">
                      <div class="mt-3">
                        <label for="faceValue" class="form-title text-nowrap"><span class="required">*</span>
                          Amount</label>
                        <input
                          id="faceValue"
                          [appOnlyNumber]="true"
                          type="text"
                          class="form-control ft-width numberText"
                          placeholder=""
                          formControlName="faceValue"
                          maxlength="13"
                          (focus)="handleFocusFaceValue()"
                          (focusout)="handleFocusOutFaceValue()"
                        />
                      </div>
                      <app-form-error-component [control]="withdrawFundForm.controls['faceValue']" />
                    </div>

                    <div
                      class="width-81 width-rs-124 custom-margin-1 align-items-center daterange_sec select_bank_filter">
                      <div class="mt-3">
                        <label for="type" class="form-title text-nowrap"><span class="required">*</span> Type</label>
                        <select
                          class="custom-form-select border-radius-100"
                          id="type"
                          formControlName="type"
                        >
                          <option *ngFor="let tt of type" [value]="tt.id">
                            {{ tt.name }}
                          </option>
                        </select>
                      </div>
                      <app-form-error-component [control]="withdrawFundForm.controls['type']" />
                    </div>

                    <div class="width-100 field-groups ">
                      <div class="mt-3">
                        <label for="date" class="form-title"><span class="required">*</span> Date</label>
                        <app-date-picker id="date" formControlName="date" [maxDate]="today"/>
                        <app-form-error-component [control]="withdrawFundForm.controls['date']" />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="mt-3">
                        <label for="comments" class="form-title">Comments</label>
                        <textarea
                          id="comments"
                          type="text"
                          class="form-control"
                          placeholder="Type somthing here..."
                          formControlName="comments"
                          row="8"
                          maxlength="512"
                        >
                        </textarea>
                      </div>
                      <app-form-error-component [control]="withdrawFundForm.controls['comments']" />
                    </div>

                    <div class="col-12 bottom-fixed">
                      <hr />
                      <div class="d-flex justify-content-center mt-3">
                        <button [disabled]="withdrawFundForm.invalid"
                                type="submit"
                                class="btn btn-light me-3 btn-custom-footer save_btn"
                                (click)="onSubmit()"
                        >Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-light btn-custom-footer cancel_btn"
                          data-dismiss="modal"
                          (click)="closeModal()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
